import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import logOut from "../../assets/images/icons/logout.svg";

const AutoLogout = ({ logout }) => {
    const timeoutRef = useRef(null);
    const logoutDelay = 60 * 60 * 1000; // 60 minutes
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);

    const triggerLogoutModal = () => {
        setShowLogoutPopup(true);
    };

    const handleCloseModal = () => {
        logout();
        setTimeout(() => {
            setShowLogoutPopup(false);
        }, 2000);
    };

    const resetTimer = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(triggerLogoutModal, logoutDelay);
    };

    useEffect(() => {
        const events = ['mousemove', 'keydown', 'scroll', 'click'];

        events.forEach(event =>
            window.addEventListener(event, resetTimer)
        );

        resetTimer(); // Start the timer initially

        return () => {
            events.forEach(event =>
                window.removeEventListener(event, resetTimer)
            );
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    return (
        <>
            <Modal
                show={showLogoutPopup}
                onHide={handleCloseModal}
                className="ftcModalPopup confirmationPopup deletionConfirmation"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Session Expired</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="editBlockContent text-center">
                        <img src={logOut} alt="logout" className="lgoutButton" />
                        <p>Your session has expired. Please log in again to continue.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-sm" variant="danger" onClick={handleCloseModal}>
                        Login
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AutoLogout;
